var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dashboards-maker" },
    [
      _c("HeaderForm", {
        attrs: {
          "is-dirty": _vm.dirty,
          "show-view-item": !!_vm.previewPath.length,
          shaking: _vm.shaking
        },
        on: {
          save: _vm.handleSave,
          delete: _vm.handleDelete,
          view: _vm.handleView,
          close: _vm.handleClose
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function() {
              return [
                _c(
                  "TextEditable",
                  {
                    attrs: { tag: "h1", icon: true },
                    on: { input: _vm.handleInputTitle }
                  },
                  [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                )
              ]
            },
            proxy: true
          },
          {
            key: "checkbox",
            fn: function() {
              return [
                _c(
                  "label",
                  {
                    staticClass: "dashboards-maker--checkbox",
                    attrs: { for: "dashboard-status" }
                  },
                  [
                    _c("input", {
                      attrs: { id: "dashboard-status", type: "checkbox" },
                      domProps: { checked: _vm.status },
                      on: { input: _vm.handleInputStatus }
                    }),
                    _vm._v("\n        " + _vm._s(_vm.publicLabel) + "\n      ")
                  ]
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c(
        "Main",
        {
          scopedSlots: _vm._u([
            {
              key: "aside",
              fn: function() {
                return [
                  _c(
                    "Aside",
                    _vm._l(_vm.cards, function(ref, key) {
                      var name = ref.name
                      return _c("SmallCard", {
                        key: key,
                        attrs: { name: name() },
                        nativeOn: {
                          drag: function($event) {
                            _vm.debounce(_vm.drag(key, $event), 1000)
                          },
                          dragend: function($event) {
                            return _vm.dragend($event)
                          }
                        }
                      })
                    }),
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _vm._v(" "),
          _vm.configuration
            ? _c("Viewer", {
                ref: "viewer",
                attrs: {
                  "is-edition-mode": true,
                  item: _vm.item,
                  config: _vm.configuration
                },
                on: {
                  "layout-updated": _vm.handleViewerUpdated,
                  "layout-ready": _vm.handleViewerReady
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }